/**
 * Splits the user-info payload into the user's own attributes and the
 * `excluded` permissions blob the API sends alongside them.
 *
 * This is handed to `useQuery()` as its `select` option. React Query memoizes
 * a `select` result against the identity of both the fetched payload and the
 * `select` function itself, so this has to stay a stable module-level
 * reference: an arrow declared inside the hook would be a new function on
 * every render, and every consumer would get a new `user` object with it.
 *
 * @param {object} response - the Axios response
 *
 * @returns {object} with the shape { excluded, user }
 */
export default function selectUserInfo({ data }) {
  const {
    excluded,
    ...user
  } = data

  return {
    excluded,
    user,
  }
}
